import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import exchangeRecord from './views/exchange-record'

export default [
  {
    path: RoutePathConstants.EXCHANGE_RECORD,
    name: 'exchangeRecord',
    component: exchangeRecord
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/exchange-record/routers.js